import { render } from "./GuideIosSetting.vue?vue&type=template&id=4553608d"
import script from "./GuideIosSetting.vue?vue&type=script&lang=js"
export * from "./GuideIosSetting.vue?vue&type=script&lang=js"

import "./GuideIosSetting.vue?vue&type=style&index=0&id=4553608d&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__